<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardBody>
          <CRow>
            <CCol>
              <strong>
                <h5>List Accepted</h5>
              </strong>
            </CCol>
            <CRow></CRow>
            <CRow class="float-right">
              <div class="search-list">
                <CCol sm="12">
                  <CInput
                    class="float-left mb-2 mr-2"
                    placeholder="Input text"
                    @input="searchCandidate($event, '')"
                  >
                    <template #prepend-content>
                      <CIcon name="cil-magnifying-glass" />
                    </template>
                  </CInput>
                </CCol>
              </div>
            </CRow>
          </CRow>
          <CDataTable
            hover
            striped
            :items="items"
            :fields="fields"
            :items-per-page="100"
            clickable-rows
            :active-page="1"
            :pagination="false"
            @page-change="pageChange"
          >
            <template #career="data">
              <td>{{ data.item.career.job_position }}</td>
            </template>
            <template #action="data">
              <td>
                <div class="button-table">
                  <CButton
                    color="primary"
                    class="mb-0 mr-1"
                    @click="rowClicked(data.item.candidate_id)"
                    >Action</CButton
                  >
                </div>
              </td>
            </template>
          </CDataTable>
          <div class="pagination-nav">
            <div
              class="pagination-btn-refresh"
              @click="searchCandidate('', 'REFRESH')"
            >
              Refresh
            </div>
            <div
              class="pagination-btn-back"
              @click="searchCandidate('', 'BACK')"
            >
              back
            </div>
            <div class="pagination-page-title">{{ activePage }}</div>
            <div
              class="pagination-btn-next"
              @click="searchCandidate('', 'NEXT')"
            >
              next
            </div>
          </div>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
// import usersData from './UsersData'
import axios from "axios";
import jwt from "jsonwebtoken";
import moment from "moment";

export default {
  name: "Accepted",
  data() {
    return {
      items: [],
      fields: [
        { key: "candidate_id", label: "ID" },
        { key: "candidate_name", label: "Nama" },
        { key: "career", label: "Posisi" },
        { key: "updated_at", label: "Tanggal Masuk" },
        { key: "action", label: "Action" },
      ],
      career: {
        job_position: "Posisi Tidak ada (karena belum memilih karir)",
      },
      activePage: 1,
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
    };
  },
  mounted() {
    this.authentication();
    this.searchCandidate("", "");
  },

  methods: {
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
        data.account_group === "HRD" ||
        data.account_group === "ADMIN" ||
        data.account_group === "ADMINISTRATOR"
      ) {
        return null;
      } else {
        this.$router.push({ path: `/` });
      }
    },

    searchCandidate(event, action) {
      if (action === "NEXT") {
        this.activePage = this.activePage + 1;
      } else if (action === "BACK") {
        if (this.activePage > 1) {
          this.activePage = this.activePage - 1;
          window.scrollTo(0, 0);
        }
      } else if (action === "REFRESH") {
        this.activePage = 1;
        window.scrollTo(0, 0);
      } else {
        this.activePage = 1;
      }
      axios
        .get(
          `${this.domain}/v1/candidate/data?page=${this.activePage}&per_page=50&q=${event}&status=ACCEPT`,
          {
            headers: {
              Authorization: this.token,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          if (response.data.data.length > 0) {
            if (this.activePage > 1) {
              window.scrollTo(0, 0);
            }
            this.items = response.data.data;
            this.items.filter((element) => {
              element.updated_at = moment(String(element.updated_at)).format(
                "MM/DD/YYYY hh:mm A"
              );
              if (element.career === null) {
                element.career = this.career;
              }
            });
          } else if (action === "NEXT") {
            this.activePage = this.activePage - 1;
          } else if (response.data.data.length === 0 && action === "") {
            this.items = response.data.data;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },

    rowClicked(item) {
      this.$router.push({ path: `/career/applicant/detail/${item}` });
    },
    pageChange(val) {
      this.$router.push({ query: { page: val } });
    },
    careerCreate() {
      this.$router.push({ path: `/career/job/create` });
    },
  },
};
</script>

<style scoped>
@import url("../Applicant.css");
</style>
